import { useEffect } from 'react';

import { useWhoAmI } from '@/api/common/auth/hooks';
import { useAuthStore } from '@/stores/useAuthStore';
import { useAuth as useClerkAuth } from '@clerk/clerk-react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

interface AuthProviderProps {
  children: React.ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const { isLoaded, isSignedIn } = useClerkAuth();
  const { setClerkAuth, setUser, setLoadingUserData, clearAuth } = useAuthStore();
  const { data: whoAmIData, isLoading: isWhoAmILoading, error } = useWhoAmI();
  const { t } = useTranslation();

  useEffect(() => {
    setClerkAuth(isLoaded, isSignedIn);

    if (!isLoaded) return;

    if (!isSignedIn) {
      clearAuth();
      toast.error(t('error.auth.unauthorized'));
      return;
    }

    if (isWhoAmILoading) {
      setLoadingUserData(true);
      return;
    }

    if (error || !whoAmIData) {
      setUser(null);
    } else {
      setUser(whoAmIData.Security.User);
    }
  }, [isLoaded, isSignedIn, whoAmIData, isWhoAmILoading, error, setClerkAuth, setUser, setLoadingUserData, clearAuth]);

  return <>{children}</>;
};
